import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function postChangePalette(upload_id, paletteValue) {
  if (!upload_id || paletteValue === undefined || paletteValue === null) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid request." },
        "Invalid request.",
        "api.project.palette.validation.invalidRequest",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/${upload_id}/change_palette`;
    const res = await fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ value: paletteValue }),
    });

    const data = await res.json().catch(() => null);

    if (!data) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
          "api.common.serverError",
        ),
      };
    }

    if (!res.ok || data?.success !== true) {
      const fallbackKey =
        res.status === 400
          ? "api.project.palette.validation.invalidRequest"
          : "api.project.palette.change.failed";

      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          data,
          "Failed to change palette.",
          fallbackKey,
        ),
      };
    }

    return {
      success: true,
      ...normalizeApiMessageWithFallbackKey(
        data,
        "Palette changed successfully.",
        "api.project.palette.change.success",
      ),
      image: data.image,
    };
  } catch (error) {
    console.error(`postChangePalette request failed: ${error}`);
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Server request failed." },
        "Server request failed.",
        "api.common.networkError",
      ),
    };
  }
}
